<template>
    <q-tabs :color="titleColor"
            :no-pane-border="mode == 'router'"
            style="width:90vw;" :style="{ 'max-width': width }"
            align="justify" :inverted="inverted">

        <component v-for="(tab, index) in tabs"
                   :is="tab.route ? 'q-route-tab' : 'q-tab'"
                   :key="tab.name"
                   :name="tab.name"
                   slot="title"
                   :icon="tab.icon"
                   :label="tab.label"
                   :to="{ name: tab.route }"
                   :default="index == 0"></component>

        <template v-if="mode == 'slots'">
            <q-tab-pane v-for="tab in tabs"
                        :name="tab.name"
                        :key="tab.name"
                        class="shadow-1"
                        :class="'bg-'+color">
                <slot :name="tab.name"></slot>
            </q-tab-pane>
        </template>

        <transition v-else name="fade" mode="out-in">
            <router-view/>
        </transition>
    </q-tabs>
</template>

<style lang="stylus">
    .q-tabs-head
        background-color transparent !important

    .q-tabs-panes
        border-top 0 !important
</style>

<script>
    import {
        QTabs,
        QTab,
        QRouteTab,
        QTabPane
    } from 'quasar-framework'

    export default {
        name: 'Tabs',

        props: {
            titleColor: {
                type: String,
                default: 'light'
            },
            inverted: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: 'white'
            },
            width: {
                type: String,
                default: '400px'
            },
            tabs: {
                type: Array,
                required: true
            },
            mode: {
                type: String,
                default: 'slots'
            }
        },

        components: {
            QTabs,
            QTab,
            QRouteTab,
            QTabPane
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Tabs.vue